import { render, staticRenderFns } from "./Step4OverLimit.vue?vue&type=template&id=dbc5e494"
import script from "./Step4OverLimit.vue?vue&type=script&lang=js"
export * from "./Step4OverLimit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports